module.exports = __webpack_public_path__ + "static/media/battleofbands.cffb0709.jpg";